import React from "react";
import icon1 from "../../assets/images/icon1.svg";
import icon2 from "../../assets/images/icon2.svg";
import icon3 from "../../assets/images/icon3.svg";
import icon4 from "../../assets/images/icon4.svg";

import {
  ServicesContainer,
  ServicesH1,
  ServiceH2,
  ServiceIcon,
  ServicesP,
  ServicesWrapper,
  ServiceCard,
} from "./ServicesElement";

const Services = () => {
  return (
    <ServicesContainer id="services">
      <ServicesH1>What I Do</ServicesH1>
      <ServicesWrapper>
        <ServiceCard>
          <ServiceIcon src={icon1} />
          <ServiceH2>Responsive</ServiceH2>
          <ServicesP>
            I made Responsive web design which looks great in any screen size📱.
          </ServicesP>
        </ServiceCard>
        <ServiceCard>
          <ServiceIcon src={icon2} />
          <ServiceH2>Styling</ServiceH2>
          <ServicesP>
            Made the website attractive and clean with minimal design and color.
          </ServicesP>
        </ServiceCard>
        <ServiceCard>
          <ServiceIcon src={icon3} />
          <ServiceH2>Scalable Website</ServiceH2>
          <ServicesP>
            Make Scaleble website with the help of React.js and Redux.
          </ServicesP>
        </ServiceCard>
        <ServiceCard>
          <ServiceIcon src={icon4} />
          <ServiceH2>Full-Stack Websites</ServiceH2>
          <ServicesP>
            Make full-Stack website with CURD operations using MERN Stack.
          </ServicesP>
        </ServiceCard>
      </ServicesWrapper>
    </ServicesContainer>
  );
};

export default Services;
